import { render } from "./Form.vue?vue&type=template&id=725ca65f&ts=true"
import script from "./Form.vue?vue&type=script&setup=true&lang=ts"
export * from "./Form.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Company/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "725ca65f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('725ca65f', __exports__)) {
    console.log('reload')
    api.reload('725ca65f', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=725ca65f&ts=true", () => {
    console.log('re-render')
    api.rerender('725ca65f', render)
  })

}


export default __exports__